import { Box, Stack, Text } from 'ui';

export interface EventLocationProps {
  venueName?: string;
  addressLineOne?: string;
  addressLineTwo?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}

export const EventLocation = ({
  venueName,
  addressLineOne,
  addressLineTwo,
  city,
  state,
  zipCode,
}: EventLocationProps) => {
  return (
    <Stack gap={4} p="md">
      <Text fz="xs" c="gray.6">
        Location
      </Text>
      <Box>
        {venueName && (
          <Text fz="sm" fw={600}>
            {venueName}
          </Text>
        )}
        <Text fz="xs" fw={500}>
          {addressLineOne ?? ''} {addressLineTwo ?? ''}
          {city ? ', ' + city : ''}
          {state ? ', ' + state : ''} {zipCode}
        </Text>
      </Box>
    </Stack>
  );
};
